export class FirebaseModel {
  public sign_in_provider: string = '';
}
